import { render, staticRenderFns } from "./EachDistrictServingElderByAge.vue?vue&type=template&id=538b5859&scoped=true&"
import script from "./EachDistrictServingElderByAge.vue?vue&type=script&lang=js&"
export * from "./EachDistrictServingElderByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b5859",
  null
  
)

export default component.exports